// import React, { useState, useEffect } from 'react';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../helpers/authContext';
import { useParams } from "react-router-dom";    
import { useDispatch, useSelector  } from 'react-redux';
import { setSteemConfig } from 'config'; 
import { get_plans, get_views } from 'services/db-service';
import PostVideoItem from 'features/posts/postVideoItem'; 
import { Helmet } from 'react-helmet-async';  
import { useToast } from 'components/ui/use-toast';
import { fetchUser } from 'features/user/userSlice';
import { RootState } from 'app/store/rootReducer';
import { getContent } from 'services/posts-service';
import { VerifiedIcon } from 'components/VerifiedIcon'; 
import PlaylistsModal from 'features/user/userModals/PlaylistsModal';
import useModal from 'helpers/useModal';

export const Playlist  = ( ) => { 
    const { toast } = useToast();
    const dispatch = useDispatch(); 
    // const navigate = useNavigate(); 
    const { id } = useParams<{ id: string }>();

    const lastDashIndex = id.lastIndexOf("-");
    const { isOpenPlaylistsModal, togglePlaylistsModal } = useModal(); 
    const username = lastDashIndex !== -1 ? id.slice(0, lastDashIndex) : id;
    // const numericId = lastDashIndex !== -1 ? id.slice(lastDashIndex + 1) : null;
    const [playlist, setPlaylist] = useState<any>(); 
    const { user, rpc_node  } = useAuth(); 
    const [currentPosts, setCurrentPosts] = useState([]); 
    const [resolvedPosts, setResolvedPosts] = useState<any[]>([]);
    // const [editPlaylist, setEditPlaylist] = useState({ name: '', description: '', cover: '', can_remix:'' });
    const [views, setViews] = useState([]);  
    const [userPlans, setUserPlans] = useState([]);
    const [creatorIsPlus, setCreatorIsPlus] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const {
        userData, 
        isLoading,
        error
    } = useSelector((state: RootState) => state.userData); 

    useEffect(() => { 
        setSteemConfig(rpc_node);
        dispatch(fetchUser(username));  
    }, [dispatch]); 
    useEffect(() => {
        const getViews = async () => { 
          let data = await get_views();
          setViews(data); 
        }
        getViews(); 
        const getPlans = async () => { 
            let data = await get_plans(); 
            setUserPlans(data); 
        }
        getPlans(); 
    }, []); 
    useEffect(() => { 
        const plan = userPlans.find(u => u.username === username);
        const isPlus = plan?.plan_type?.includes("plus") || false;
        setCreatorIsPlus(isPlus);
    }, [userPlans]); 
    
    useEffect(()=> {
        if (!isLoading) {
            let d = null;
            try {
                d = (JSON.parse(userData.json_metadata)?.playlists); 
            } catch (error) {
                setErrorMessage("While getting profile"); 
            } 

            const playlistIndex = d.findIndex(
                (pl: any) => pl.id === id
            );

            if (playlistIndex === -1) {
                setErrorMessage("Playlist not found" );
            }

            const playlist = d[playlistIndex];
            setPlaylist(playlist || []);
        } 
    },[userData]); 
    useEffect(() => { 
        if (playlist) {
            setCurrentPosts(playlist?.items || []); 
        }
    }, [playlist]); 
    useEffect(() => {
        const resolvePosts = async () => {
            if (!currentPosts || currentPosts.length === 0) {
            setResolvedPosts([]);
            return;
            }

            const resolved = await Promise.all(
            currentPosts.map(async (post) => {
                const postUrl = `/@${post.author}/${post.permlink}`;
                const view = views.find(v => v.url === postUrl);
                const viewsCount = view ? view.count : 0;

                let postData = post;

                if (!post.created) {
                postData = await getContent(post.author, post.permlink);
                }

                return {
                ...postData,
                views: viewsCount
                };
            })
            );

            setResolvedPosts(resolved);
        };

        resolvePosts();
    }, [currentPosts, views]);

    // const renderPosts = () => { 
    //     if(currentPosts.length == 0){ 
    //         return (
    //             <div className='text-center w-100'><strong>No posts yet.</strong></div>
    //         )
    //     }
    //     let section = currentPosts.map(async (post, index) => { 
    //         const postUrl = `/@${post.author}/${post.permlink}`;
    //         const view = views.find(v => v.url === postUrl);
    //         const viewsCount = view ? view.count : 0; 
    //         const plan = userPlans.find(u => u.username === post.author);  
    //         let isPlus = plan?.plan_type?.includes("plus") || false;
    //         let postData;
    //         if (!post.created) {
    //             postData = await getContent(post.author, post.permlink);
    //             postData = {
    //                 ...postData, 
    //                 views:viewsCount
    //             }; 
    //         }else {
    //             postData = {
    //                 ...post, 
    //                 views:viewsCount
    //             }; 
    //         } 
    //         return (
    //             <div
    //             key={`${post.id}-${index}`}
    //             className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 p-2" 
    //             >
    //                 <PostVideoItem post={postData} isPlus={isPlus} />
    //             </div>
    //         );
    //     });
    //     return section;
    // }  
    const renderPosts = () => {
        if (resolvedPosts.length === 0) {
            return (
            <div className="text-center w-100">
                <strong>No posts yet.</strong>
            </div>
            );
        }

        return resolvedPosts.map((post) => {
            const plan = userPlans.find(u => u.username === post.author);
            const isPlus = plan?.plan_type?.includes("plus") || false;

            return (
            <div
                key={`${post.author}-${post.permlink}`}
                className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 p-2"
            >
                <PostVideoItem post={post} isPlus={isPlus} canBeDeleted={user == username} playlistId={id} />
            </div>
            );
        });
    };

    if (error) {
        console.log(error);
        toast({
            title: "Error",
            description: error,
            variant:"rose_red"
        });  
    }
    if (errorMessage) {
        console.log(errorMessage);
        toast({
            title: "Error",
            description: errorMessage,
            variant:"rose_red"
        }); 
    }

    return (
        <div className="user-settings mt-2 container-fluid"> 
        <Helmet>
            {/* <title>{(profileData.name || "") +" - Speak on Steem"}</title>
            <meta name="description" content={profileData.about} /> 
            <meta property="og:title" content={`${profileData.name || ""} - Speak on Steem`} />
            <meta property="og:description" content={profileData.about} />
            <meta property="og:image" content={profileData.avatar} />
            <meta property="og:type" content="profile" /> 
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={`${profileData.name} - Speak on Steem`} />
            <meta name="twitter:description" content={profileData.about} />
            <meta name="twitter:image" content={profileData.avatar} /> */}
        </Helmet>
            <div className="card-stats card item-speem mb-0">
                {/* {(!isLoading && userCover) && userCover} */}
                <div className="card-body p-0" >
                    <div className="row profile-container d-flex p-2"> 
                        <div className="col-12 col-sm-12 col-md-3 col-lg-auto text-center text-sm-center text-md-left p-0">
                            <div className="profile-image-container">
                                <img
                                    src={playlist?.cover || "/assets/img/playlists.png"}
                                    alt="Profile"
                                    className="playlist-image"
                                />
                            </div> 
                        </div> 
        
                        <div className="col-12 col-sm-12 col-md-9  col-lg-auto text-center text-sm-center text-md-left"> 
                            <div className="d-inline-block">
                                <div className="d-flex">
                                    <h3 className={`fw-bold me-3 m-0 `}>
                                        {(playlist && playlist.name) && playlist.name}
                                        <div className="ml-3 profile-name text-muted">
                                            By <a className='playlist-creator' href={`/u/playlists/${username}`}>{`${username}`}</a>
                                            {(creatorIsPlus) && (<div className="text-muted d-inline-block"  title='Verified Plus member.' style={{marginRight:"2px", cursor:"pointer"}}><VerifiedIcon size={30} className="color-speem" /> </div> )}
                                        </div>
                                    </h3>  
                                </div>  
                            </div> 
                            <div className="profile-about text-muted mb-1">{(playlist && playlist.description)?playlist.description:""}</div>
                            {/* <div className="btn btn-action">
                                <i className="fas fa-retweet"></i>
                            </div> */}
                            <a href={`/p/${playlist?.items[0]?.author}/${playlist?.items[0]?.permlink}`  || "#"} className="btn btn-action">
                                <i className="fas fa-play"></i>
                            </a>
                            {user == username && (
                                <div className="btn btn-action" onClick={() => togglePlaylistsModal()}>
                                    <i className="fas fa-pencil"></i>
                                </div>
                            )}
                            
                        </div> 
        
                    </div>
                    
                </div>
            </div>  
            <div className="p-0 mb-2">
                <div className="container-fluid p-0">
                    <div className="col-12 p-0">
                        
                    </div>
                </div>
            </div>
            <div className="row p-0 m-0">  
                {renderPosts()}
            </div>
            <PlaylistsModal
                isShowing={isOpenPlaylistsModal}
                hide={togglePlaylistsModal}
                edit={true}
                editItem={playlist}
            />
        </div>
    );
};